<template>
  <div class="pay-success">
    <div class="main-content">
      <div></div>
      <div class="success-tip">恭喜你报名成功！</div>
      <!-- <div class="contant-info">
        <p>电子票已发送至购买人邮箱：{{buyerEmail}}</p>
        <p>如有疑问欢迎咨询客户热线：0571-25593149</p>
      </div> -->
      <!-- <div class="code-text">访问LIGHT云，查看更多在线服务</div> -->
      <router-link to="/serviceProduct" tag="div" class="code-text"
        >访问恒生LIGHT云，查看更多在线服务</router-link
      >
      <div class="code-img">
        <img src="../../../assets/developerConference/code_img.jpg" alt="" />
      </div>
      <div class="follow-hs">关注恒生官微，第一时间掌握会议动态</div>
    </div>
  </div>
</template>
<script>
// import { getBuyerInfo } from '@/api/developerConference.js'
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {
    // if (this.$route.query.tickets_id) {
    //   this.getBuyerInfoFn()
    // } else {
    //   this.$router.push({ path: '/developerConference/ticketing' })
    // }
  },

  methods: {
    // getBuyerInfoFn() {
    //   let id = this.$route.query.tickets_id
    //   getBuyerInfo(id).then(res => {
    //     if (res) {
    //       this.buyerEmail = res.email
    //     } else {
    //       this.$router.push({ path: '/developerConference/ticketing' })
    //     }
    //   })
    // }
  }
};
</script>
<style lang="scss" scoped>
.pay-success {
  overflow: hidden;
  .main-content {
    width: 1200px;
    height: 816px;
    margin: 103px auto 24px;
    background: #fff;
    text-align: center;
    font-size: 16px;
    padding-top: 126px;
    > div:nth-child(1) {
      width: 60px;
      height: 60px;
      background: url("../../../assets/developerConference/success_pay.png")
        no-repeat center;
      background-size: 100% 100%;
      margin: 0 auto 24px;
    }
    .success-tip {
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #333333;
      margin-bottom: 24px;
      font-weight: 700;
    }
    .contant-info {
      font-family: PingFangSC-Regular;
      color: #888888;
      line-height: 28px;
      margin-bottom: 28px;
    }
    .code-text {
      margin: 0 auto;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #1f70fd;
      line-height: 36px;
      border: 1px solid #1f70fd;
      border-radius: 4px;
      width: 285px;
      height: 36px;
      margin-bottom: 80px;
      cursor: pointer;
    }
    .code-img {
      width: 116px;
      height: 116px;
      margin: 0 auto 36px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      &:before {
        display: inline-block;
        content: "";
        width: 16px;
        height: 16px;
        background: url("../../../assets/developerConference/code_img_top.png")
          no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        top: -2px;
        left: -2px;
      }
      &:after {
        display: inline-block;
        content: "";
        width: 16px;
        height: 16px;
        background: url("../../../assets/developerConference/code_img_bottom.png")
          no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        bottom: -2px;
        right: -2px;
      }
    }
    .follow-hs {
      font-family: PingFangSC-Regular;
      color: #999999;
      line-height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/paySuccess.vue